import React from "react";
import { Helmet } from "react-helmet";
function Acceptusagepolicy() {
  return (
    <>
      <Helmet>
        <title>Acceptable Usage Policy » ClubHosty</title>
        <link
          rel="canonical"
          href="https://www.clubhosty.com/accept-usage-policy"
        />
      </Helmet>
      <main id="main">
        <section class="breadcrumbs">
          <div class="container">
            <div>
              <h2>Acceptable Usage Policy</h2>
              <center>
                <p>
                  Please read the AUP of ClubHosty in order to get a hassle-free
                  web hosting service from ClubHosty.
                </p>
              </center>
            </div>
          </div>
        </section>

        {/* ======= Services Section =======  */}
        <section id="services" class="services">
          <div class="container" data-aos="fade-up">
            <div class="row">
              <div class="col-md-12 section-heading">
                <h3>General Acceptable Use Policy</h3>
                <p>
                  <i class="fa fa-angle-double-right"></i> This AUP governs the
                  use of ClubHosty's hosting service. Violation of this AUP may
                  result in suspension or termination of your service. In the
                  event of a dispute between you and ClubHosty regarding the
                  interpretation of this AUP, ClubHosty's interpretation, in its
                  reasonable commercial judgment, shall govern.
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> The following is the
                  entire Acceptable User Policy ("AUP") agreement between
                  ClubHosty and the personal or corporate account holder.
                  ClubHosty provides managed web hosting and domain name
                  service. ClubHosty has certain legal and ethical
                  responsibilities consisting of the use of its servers and
                  equipment involved in these services.{" "}
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> ClubHosty's general
                  policy is to act as a provider of Internet presence. ClubHosty
                  reserves the right to suspend or cancel a customer's access to
                  any or all services provided by ClubHosty when we decide that
                  the account has been inappropriately used.
                </p>
              </div>
              <div class="section-heading">
                <h3>What is Appropriate Usage?</h3>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> ClubHosty web hosting
                  solution has specifically been designed to serve the web
                  hosting needs of small and independently owned and operated
                  businesses and organizations throughout the world.{" "}
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Since you will be
                  hosting your website with several other clients on our servers
                  in a virtual community, our offerings are not intended to
                  support enterprise-level or large company requirements. For
                  that, we recommend purchasing at least a virtual private
                  server, dedicated server solution.
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> ClubHosty hosting is
                  a shared web hosting service, which ultimately means several
                  customers' websites are hosted within the same server
                  environment. To ensure that our hosting is first-class,
                  reliable, and available to all customers within that server
                  community, an individual customer's website usage cannot
                  adversely affect the performance of other customers' sites.{" "}
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> We monitor our
                  servers 24/7/365 and in no way can one customer adversely
                  affect the performance of that server. If this happens, we
                  will take preventative measures to ensure that the entire
                  community is protected.
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Lastly, our web
                  hosting service is intended to host websites, not backup or
                  storage facility for users' data. Using your web hosting
                  account primarily as an online storage space for archiving
                  electronic files and images is strictly prohibited. Our
                  servers are for web hosting usage only.
                </p>
              </div>
              <div class="section-heading">
                <h3>Prohibited Content</h3>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> You may not publish
                  or transmit via ClubHosty's service any content that ClubHosty
                  reasonably believes:
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Constitutes child
                  pornography
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Constitutes
                  pornography{" "}
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Excessively violent,
                  incites violence, threatens violence, or contains harassing
                  content or hate speech
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Unfair or deceptive
                  under the consumer protection laws of any jurisdiction,
                  including chain letters and pyramid schemes
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Defamatory or
                  violates a person's privacy
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Creates a risk to a
                  person's safety or health, creates a risk to public safety or
                  health, compromises national security, or interferes with an
                  investigation by law enforcement
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Improperly exposes
                  trade secrets or other confidential or proprietary information
                  of another person
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Intended to assist
                  others in defeating technical copyright protections
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Otherwise malicious,
                  fraudulent, or may result in retaliation against ClubHosty by
                  offended viewers
                </p>
              </div>
              <div class="section-heading">
                <h3>ClubHosty does not accept material such as:</h3>
                <p class="lead">
                  Proxy, Warez, Escrow, High Yield Investment Programs(HYIP),
                  illegal Gambling and Lottery sites.
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> And please read our
                  refund policy if you are planning for a refund.
                </p>
              </div>
              <div class="section-heading">
                <h3>Security</h3>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> You must take
                  reasonable security precautions. You must protect the
                  confidentiality of your password, and you should change your
                  password periodically.
                </p>
              </div>
              <div class="section-heading">
                <h3>ClubHosty does not accept material such as:</h3>
                <p class="lead">
                  Proxy, Warez, Escrow, High Yield Investment Programs(HYIP),
                  illegal Gambling and Lottery sites.
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> And please read our
                  refund policy if you are planning for a refund.
                </p>
              </div>
              <div class="section-heading">
                <h3>Backup</h3>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> ClubHosty in any case
                  is not responsible for backup of your files / emails or any
                  data being uploaded on our server. However we generate a
                  backup for an extreme situations where in case failure of
                  server or major technical issue arises and in such case the
                  backup generated will be restored with no guarantee. The
                  backup (if applicable) generated by us cannot be downloaded
                  but only be restored on request received by the registered
                  user via ticket from the member’s dashboard without any
                  guarantee of being 100% as it was. You’re always advised to
                  take backup of your hosting account manually once on
                  fortnightly / monthly basis to be always safe.
                </p>
              </div>
              <div class="section-heading">
                <h3>Material Protected By Copyright</h3>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> You may not publish,
                  distribute, or otherwise copy in any manner any music,
                  software, art, or other work protected by copyright law
                  unless:
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> You have been
                  expressly authorized by the owner of the copyright for the
                  work to copy the work in that manner.
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> You are otherwise
                  permitted by established United States copyright law to copy
                  the work in that manner.
                </p>
                <strong>
                  ClubHosty will terminate the service of repeat copyright
                  infringers.
                </strong>
              </div>
              <div class="section-heading">
                <h3>Extra</h3>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> You must have valid
                  and current information on file with your domain name
                  registrar for any domain hosted on the ClubHosty network.
                </p>
              </div>
              <div class="section-heading">
                <h3>Disclaimer</h3>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> ClubHosty is under no
                  duty and does not by this AUP undertake a duty, to monitor or
                  police our customers' activities and disclaims any
                  responsibility for any misuse of the ClubHosty network.
                </p>
              </div>
              <div class="section-heading">
                <h3>Internet Abuse</h3>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Unauthorized access
                  to our use of data, systems or networks, including any attempt
                  to probe, scan or test the vulnerability of a system or
                  network or to breach security or authentication measures
                  (including those belonging to ClubHosty and its customers)
                  without express authorization of the owner of the system or
                  network;
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Monitoring data or
                  traffic on any network or system without the authorization of
                  the owner of the system or network;
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Interference with
                  service to any user, host or network including, without
                  limitation, mail bombing, flooding, deliberate attempts to
                  overload a system and broadcast attacks;
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Use of an Internet
                  account or computer without the owner's authorization,
                  including, but not limited to Internet scanning (tricking
                  other people into releasing their passwords), password
                  robbery, security hole scanning, and port scanning;
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Forging of any TCP-IP
                  packet header or any part of the header information in an
                  e-mail or a newsgroup posting
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Any conduct that is
                  likely to result in retaliation against the ClubHosty network.
                </p>
                <p>
                  {" "}
                  <i class="fa fa-angle-double-right"></i> Use of ClubHosty's
                  network in a way that unreasonably interferes with ClubHosty's
                  other customers' use of the network.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* End Services Section  */}
      </main>
      {/* End #main */}
    </>
  );
}

export default Acceptusagepolicy;
